import { media } from '@/media';
import styled from 'styled-components';

export const ListWrapper = styled.div`
  ${media.mobile`
    margin-top: 40px
  `}
`;
